import { saveSpreadsheet } from '../../utils/spreadsheet/save';

export type JourneyAnalyticsEntry = {
  id: number;
  firstName?: string;
  lastName?: string;
  internalId?: string;
  pictureUrl?: string;
  phoneNumber?: string;
  email?: string;
  startDate?: string;
  departmentName: string;
  jobTitleName: string;
  regionName: string;
  /**
   * @deprecated use {@link AdminUserDto.units}
   */
  unitIds: number[];
  units: string[];
  roles: string[];
  disabledFrom?: string;
  journeyProgressPercentage: number;
  journeyActivitiesDoneTotal: number;
  journeyActivitiesTotal: number;
};

export const createJourneyAnalyticsListExporter = (params: {
  journeyName: string;
}) => {
  return async (analyticsEntries: JourneyAnalyticsEntry[]) => {
    const mapped = analyticsEntries.map((entry: JourneyAnalyticsEntry) => {
      return {
        ['ID']: entry.id,
        ['Internal ID']: entry.internalId,
        ['First Name']: entry.firstName,
        ['Last Name']: entry.lastName,
        ['Job Title']: entry.jobTitleName,
        ['Department']: entry.departmentName,
        ['Region']: entry.regionName,
        ['Unit']: entry.units.join(', '),
        ['Journey Activities Done %']: entry.journeyProgressPercentage,
        ['Journey Activities Total']: entry.journeyActivitiesTotal,
        ['Journey Activities Done']: entry.journeyActivitiesDoneTotal,
      };
    });

    await saveSpreadsheet({
      format: 'csv',
      data: mapped,
      basename: `${params.journeyName} Analytics`,
    });
  };
};
